module.exports = __webpack_public_path__ + "static/media/information-icon.b979cdf8.svg";